import React from 'react';

export type TrainerMode = 'view' | 'edit';

export type TrainerModeToggleProps = {
  mode: TrainerMode;
  onView: () => void;
  onEdit: () => void;
  editDisabled?: boolean;
  className?: string;
};

/** Shared View/Edit segmented control — 40px outer, Workout language. */
export function TrainerModeToggle({
  mode,
  onView,
  onEdit,
  editDisabled = false,
  className,
}: TrainerModeToggleProps) {
  const classes = ['tr-mode-toggle', className].filter(Boolean).join(' ');
  return (
    <div className={classes} role="group" aria-label="View or edit mode">
      <button
        type="button"
        className="tr-mode-btn"
        aria-pressed={mode === 'view'}
        onClick={onView}
      >
        View
      </button>
      <button
        type="button"
        className="tr-mode-btn"
        aria-pressed={mode === 'edit'}
        aria-disabled={editDisabled}
        disabled={editDisabled}
        onClick={() => {
          if (!editDisabled) onEdit();
        }}
      >
        Edit
      </button>
    </div>
  );
}
